import Configuration from "./configuration";

/**
 * @deprecated replaced for ConfigurationService. Not use
 */
class CompanyService {
  constructor(token) {
    this.config = new Configuration(token, null, "api/Company");
  }

  /**
   * @method getCompanies list companies
   * @return {Promise} result object providers
   */
  async getCompanies(take = 5, skip = 0) {
    return this.config.API.get(`GetCompanies`, {
      params: {
        skip,
        take
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method createCompany create company
   * @return {Promise} result object providers
   */
  async createCompany(company) {
    return this.config.API.post(`CreateCompany`, company).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method updateCompany update company
   * @return {Promise} result object providers
   */
  async updateCompany(company) {
    return this.config.API.post(`UpdateCompany`, company).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method disableCompany disable xompany
   * @return {Promise} result object providers
   */
  async disableCompany(companyId) {
    return this.config.API.get(`DisableCompany`, {
      params: {
        companyId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method activateCompany update company
   * @return {Promise} result object providers
   */
  async activateCompany(companyId) {
    return this.config.API.get(`ActivateCompany`, {
      params: {
        companyId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method upFile upload file
   * @return {Promise}
   */
  async upFile(formData) {
    return this.config.API.post(`UpFile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(response => {
      if (response.status !== 200)
        return this.config.handleResponseError(response);
      return response.data;
    });
  }


  /**
   * @method sendEmail send email contact
   * @return {Promise}
   */
  async sendEmail(message, receiver, subject, contact) {
    return this.config.API.post(`SendEmail`, {
      message,
      receiver,
      subject,
      contact
    }).then(response => {
      if (response.status !== 200)
        return this.config.handleResponseError(response);
      return response.data;
    });
  }
}

export default CompanyService;
